import {CalendarDayV2, EVENT_FILTER_TYPE} from '@wix/wix-events-commons-statics'
import {ControllerFlowAPI} from '@wix/yoshi-flow-editor'
import {setBaseEnvironment, setBaseEnvironmentOld, setFormFactor} from '../../../../commons/actions/environment'
import {RIBBON} from '../../../../commons/constants/ribbons'
import {CommonState, CommonStoreExtraArgs, DemoEvents, SiteSettings} from '../../../../commons/types/state'
import {EVENT_BADGE} from '../../../../settings-commons/components/event-badges/interfaces'
import {WidgetComponentConfig} from '../../types'
import {
  addCalendarMonth,
  addCalendarMonthOld,
  closeMonthlyCalendarEvent,
  closeMonthlyCalendarPopup,
  openMonthlyCalendarEvent,
  openMonthlyCalendarPopup,
  resetCalendar,
  resetCalendarOld,
  subCalendarMonth,
  subCalendarMonthOld,
} from '../actions/calendar-layout'
import {selectCategory} from '../actions/categories'
import {updateStyles} from '../actions/component'
import {shareEvent} from '../actions/event'
import {loadEventsPage} from '../actions/events'
import {closeListLayoutItems, openListLayoutItem, widgetLoaded} from '../actions/layout'
import {openMembersModal, openMembersModalOld} from '../actions/members'
import {navigateToPage, navigateToPageOld, onLinkNavigatedToPage} from '../actions/navigate-to-page'
import {updateSettings, updateSettingsOld} from '../actions/sdk'
import {CategoriesState} from '../reducers/categories'
import {DynamicVeloOverridesState} from '../reducers/velo-overrides'
import {Api} from '../utils/api'

export interface Actions {
  addCalendarMonth: typeof addCalendarMonth
  addCalendarMonthOld: typeof addCalendarMonthOld
  resetCalendar: typeof resetCalendar
  resetCalendarOld: typeof resetCalendarOld
  subCalendarMonth: typeof subCalendarMonth
  subCalendarMonthOld: typeof subCalendarMonthOld
  navigateToPageOld: typeof navigateToPageOld
  navigateToPage: typeof navigateToPage
  onLinkNavigatedToPage: typeof onLinkNavigatedToPage
  updateStyles: typeof updateStyles
  updateSettingsOld: typeof updateSettingsOld
  updateSettings: typeof updateSettings
  setBaseEnvironmentOld: typeof setBaseEnvironmentOld
  setBaseEnvironment: typeof setBaseEnvironment
  closeListLayoutItems: typeof closeListLayoutItems
  openListLayoutItem: typeof openListLayoutItem
  openMonthlyCalendarPopup: typeof openMonthlyCalendarPopup
  closeMonthlyCalendarPopup: typeof closeMonthlyCalendarPopup
  openMonthlyCalendarEvent: typeof openMonthlyCalendarEvent
  closeMonthlyCalendarEvent: typeof closeMonthlyCalendarEvent
  widgetLoaded: typeof widgetLoaded
  openMembersModalOld: typeof openMembersModalOld
  openMembersModal: typeof openMembersModal
  shareEvent: typeof shareEvent
  setFormFactor: typeof setFormFactor
  loadEventsPage: typeof loadEventsPage
  selectCategory: typeof selectCategory
}

export interface State extends CommonState {
  events: Events
  component: WidgetComponentConfig
  demoEvents: DemoEvents
  layout: Layout
  calendarLayout: CalendarLayout
  categories: CategoriesState
  owner: boolean
  memberLoggedIn: boolean
  dynamicVeloOverrides: DynamicVeloOverridesState
  siteSettings: SiteSettings
}

export interface Events {
  events: ExtendedEvent[]
  moreLoading: boolean
  hasMore: boolean
  filterType: EVENT_FILTER_TYPE
  latestRequestId: string
}

export interface Layout {
  listItemOpened: string
  forceShowRibbon: RIBBON
  forcedEventBadge: EVENT_BADGE
}

export enum CalendarLoading {
  DEFAULT = 1,
  PREVIOUS,
  NEXT,
}

export interface CalendarLayout {
  referenceDate: string
  today: string
  month: Dictionary<{
    next: string
    previous: string
    fullMonthText: string
  }>
  monthly: MonthlyCalendarLayout
  weekDayNames: string[]
  loadedPages: string[]
  loading: CalendarLoading
  events: Dictionary<string[]>
  demoEvents: Dictionary<string[]>
  days: Dictionary<CalendarDayV2>
}

export interface MonthlyCalendarLayout {
  selectedDate: string
  selectedEventId: string
}

export type GetState = () => State

export interface StoreExtraArgs extends CommonStoreExtraArgs {
  serverApi: Api
  flowAPI: ControllerFlowAPI
}
